import types from "./types";

export default (
  state = {
    isFetchingList: false,
    persons: [],
    personsListError: "",

    isFetchingRoleList: false,
    roles: [],
    rolesListError: "",

    isFetchingPersonOrgList: false,
    personOrgList: [],
    personOrgListError: "",

    isFetchingHistory: false,
    history: [],
    historyError: "",

    isFetchingAttachList: false,
    attachments: [],
    attachmentsError: "",
    isDeletingAttachment: false,
    deletedAttachment: null,
    deletingAttachmentError: "",

    isFetchingSnilsAttachList: false,
    attachmentsSnils: [],
    attachmentsSnilsError: "",
    isDeletingSnilsAttachment: false,
    deletedSnilsAttachment: null,
    deletingSnilsAttachmentError: "",

    isFetchingPerson: false,
    personCard: null,
    personCardError: "",
    isFetchingFullPerson: false,
    personFullInfo: null,
    personFullError: "",
    isFetchingSystem: false,
    systemInfo: null,
    systemError: "",
    isDeletingPersons: false,
    deletedPersons: null,
    deletingPersonsError: "",
    isImportingPersons: false,
    importedPersons: null,
    importingPersonsError: "",
    isUpdatingPerson: false,
    updatedPerson: null,
    personUpdateError: "",

    isUpdatingRoles: false,
    updatedRoles: null,
    rolesUpdateError: "",

    isCreatingPerson: false,
    createdPerson: null,
    personCreationError: "",
    isBlockingPerson: false,
    blockedPerson: null,
    personBlockError: "",
    isFetchingMunicipalsList: false,
    municipals: [],
    municipalsError: "",
    isFetchingDocPerson: false,
    personDocInfo: null,
    personDocError: "",
    isFetchingWsList: false,
    worldSkills: [],
    wsListError: "",
    isFetchingSkillsList: false,
    skills: [],
    skillsListError: "",
    isFetchingOrganizations: false,
    organizations: [],
    organizationsError: "",
    isFetchingDepartments: false,
    departments: [],
    departmentsError: "",
    isFetchingPosts: false,
    posts: [],
    postsError: "",

    isUpdatingAvatar: false,
    updatedAvatar: null,
    avatarUpdateError: "",
  },
  action
) => {
  switch (action.type) {
    case types.GET_PERSONS_REQUEST:
      return {
        ...state,
        isFetchingList: action.isFetchingList
      };
    case types.GET_PERSONS_COMPLETED:
      return {
        ...state,
        isFetchingList: action.isFetchingList,
        persons: action.persons
      };
    case types.GET_PERSONS_ERROR:
      return {
        ...state,
        isFetching: action.isFetching,
        personsError: action.personsError
      };

    case types.GET_PERSON_HISTORY_REQUEST:
      return {
        ...state,
        isFetchingHistory: action.isFetchingHistory
      };
    case types.GET_PERSON_HISTORY_COMPLETED:
      return {
        ...state,
        isFetchingHistory: action.isFetchingHistory,
        history: action.history
      };
    case types.GET_PERSON_HISTORY_ERROR:
      return {
        ...state,
        isFetchingHistory: action.isFetchingHistory,
        historyError: action.historyError
      };

    case types.GET_PERSON_ROLES_REQUEST:
      return {
        ...state,
        isFetchingRoleList: action.isFetchingRoleList
      };
    case types.GET_PERSON_ROLES_COMPLETED:
      return {
        ...state,
        isFetchingRoleList: action.isFetchingRoleList,
        roles: action.roles
      };
    case types.GET_PERSON_ROLES_ERROR:
      return {
        ...state,
        isFetchingRoleList: action.isFetchingRoleList,
        rolesError: action.rolesError
      };

    case types.GET_PERSON_ORGANIZATIONS_REQUEST:
      return {
        ...state,
        isFetchingPersonOrgList: action.isFetchingPersonOrgList
      };
    case types.GET_PERSON_ORGANIZATIONS_COMPLETED:
      return {
        ...state,
        isFetchingPersonOrgList: action.isFetchingPersonOrgList,
        personOrgList: action.personOrgList
      };
    case types.GET_PERSON_ORGANIZATIONS_ERROR:
      return {
        ...state,
        isFetchingRoleList: action.isFetchingRoleList,
        personOrgListError: action.personOrgListError
      };

    case types.GET_PERSON_SKILLS_REQUEST:
      return {
        ...state,
        isFetchingSkillsList: action.isFetchingSkillsList
      };
    case types.GET_PERSON_SKILLS_COMPLETED:
      return {
        ...state,
        isFetchingSkillsList: action.isFetchingSkillsList,
        skills: action.skills
      };
    case types.GET_PERSON_SKILLS_ERROR:
      return {
        ...state,
        isFetchingSkillsList: action.isFetchingSkillsList,
        skillsError: action.skillsError
      };
    case types.GET_PERSON_WS_REQUEST:
      return {
        ...state,
        isFetchingWsList: action.isFetchingWsList
      };
    case types.GET_PERSON_WS_COMPLETED:
      return {
        ...state,
        isFetchingWsList: action.isFetchingWsList,
        worldSkills: action.worldSkills
      };
    case types.GET_PERSON_WS_ERROR:
      return {
        ...state,
        isFetchingWsList: action.isFetchingWsList,
        wsError: action.wsError
      };
    case types.GET_PERSON_DOCUMENT_ATTACHMENTS_REQUEST:
      return {
        ...state,
        isFetchingAttachList: action.isFetchingAttachList
      };
    case types.GET_PERSON_DOCUMENT_ATTACHMENTS_COMPLETED:
      return {
        ...state,
        isFetchingAttachList: action.isFetchingAttachList,
        attachments: action.attachments
      };
    case types.GET_PERSON_DOCUMENT_ATTACHMENTS_ERROR:
      return {
        ...state,
        isFetchingAttachList: action.isFetchingAttachList,
        attachmentsError: action.attachmentsError
      };
    case types.GET_PERSON_SNILS_ATTACHMENTS_REQUEST:
      return {
        ...state,
        isFetchingSnilsAttachList: action.isFetchingSnilsAttachList
      };
    case types.GET_PERSON_SNILS_ATTACHMENTS_COMPLETED:
      return {
        ...state,
        isFetchingSnilsAttachList: action.isFetchingSnilsAttachList,
        attachmentsSnils: action.attachmentsSnils
      };
    case types.GET_PERSON_SNILS_ATTACHMENTS_ERROR:
      return {
        ...state,
        isFetchingSnilsAttachList: action.isFetchingSnilsAttachList,
        attachmentsSnilsError: action.attachmentsSnilsError
      };
    case types.GET_PERSON_REQUEST:
      return {
        ...state,
        isFetchingPerson: action.isFetchingPerson
      };
    case types.GET_PERSON_COMPLETED:
      return {
        ...state,
        isFetchingPerson: action.isFetchingPerson,
        personCard: action.personCard
      };
    case types.GET_PERSON_ERROR:
      return {
        ...state,
        isFetchingPerson: action.isFetchingPerson,
        personCardError: action.personCardError
      };
    case types.GET_FULL_PERSON_REQUEST:
      return {
        ...state,
        isFetchingFullPerson: action.isFetchingFullPerson
      };
    case types.GET_FULL_PERSON_COMPLETED:
      return {
        ...state,
        isFetchingFullPerson: action.isFetchingFullPerson,
        personFullInfo: action.personFullInfo
      };
    case types.GET_FULL_PERSON_ERROR:
      return {
        ...state,
        isFetchingFullPerson: action.isFetchingFullPerson,
        personFullError: action.personFullError
      };
    case types.GET_DOC_PERSON_REQUEST:
      return {
        ...state,
        isFetchingDocPerson: action.isFetchingDocPerson
      };
    case types.GET_DOC_PERSON_COMPLETED:
      return {
        ...state,
        isFetchingDocPerson: action.isFetchingDocPerson,
        personDocInfo: action.personDocInfo,
        personDocError: null
      };
    case types.GET_DOC_PERSON_ERROR:
      return {
        ...state,
        isFetchingDocPerson: action.isFetchingDocPerson,
        personDocError: action.personDocError,
        personDocInfo: null,
      };
    case types.DELETE_PERSONS_REQUEST:
      return {
        ...state,
        isDeletingPersons: action.isDeletingPersons
      };
    case types.DELETE_PERSONS_COMPLETED:
      return {
        ...state,
        isDeletingPersons: action.isDeletingPersons,
        deletedPerson: action.deletedPerson
      };
    case types.DELETE_PERSONS_ERROR:
      return {
        ...state,
        isDeletingPersons: action.isDeletingPersons,
        deletingPersonsError: action.deletingPersonsError
      };
    case types.IMPORT_PERSONS_REQUEST:
      return {
        ...state,
        isImportingPersons: action.isImportingPersons
      };
    case types.IMPORT_PERSONS_COMPLETED:
      return {
        ...state,
        isImportingPersons: action.isImportingPersons,
        importedPerson: action.importedPerson
      };
    case types.IMPORT_PERSONS_ERROR:
      return {
        ...state,
        isImportingPersons: action.isImportingPersons,
        importingPersonsError: action.importingPersonsError
      };
    case types.UPDATE_PERSON_REQUEST:
      return {
        ...state,
        isUpdatingPerson: action.isUpdatingPerson
      };
    case types.UPDATE_PERSON_COMPLETED:
      return {
        ...state,
        isUpdatingPerson: action.isUpdatingPerson,
        updatedPerson: action.updatedPerson
      };
    case types.UPDATE_PERSON_ERROR:
      return {
        ...state,
        isUpdatingPerson: action.isUpdatingPerson,
        personUpdateError: action.personUpdateError
      };

    case types.UPDATE_PERSON_ROLES_REQUEST:
      return {
        ...state,
        isUpdatingRoles: action.isUpdatingRoles
      };
    case types.UPDATE_PERSON_ROLES_COMPLETED:
      return {
        ...state,
        isUpdatingRoles: action.isUpdatingRoles,
        updatedRoles: action.updatedRoles
      };
    case types.UPDATE_PERSON_ROLES_ERROR:
      return {
        ...state,
        isUpdatingRoles: action.isUpdatingRoles,
        rolesUpdateError: action.rolesUpdateError
      };

    case types.CREATE_PERSON_REQUEST:
      return {
        ...state,
        isCreatingPerson: action.isCreatingPerson
      };
    case types.CREATE_PERSON_COMPLETED:
      return {
        ...state,
        isCreatingPerson: action.isCreatingPerson,
        createdPerson: action.createdPerson
      };
    case types.CREATE_PERSON_ERROR:
      return {
        ...state,
        isCreatingPerson: action.isCreatingPerson,
        personCreationError: action.personCreationError
      };

    case types.BLOCK_PERSON_REQUEST:
      return {
        ...state,
        isBlockingPerson: action.isBlockingPerson
      };
    case types.BLOCK_PERSON_COMPLETED:
      return {
        ...state,
        isBlockingPerson: action.isBlockingPerson,
        blockedPerson: action.blockedPerson
      };
    case types.BLOCK_PERSON_ERROR:
      return {
        ...state,
        isBlockingPerson: action.isBlockingPerson,
        personBlockError: action.personBlockError
      };

    case types.DELETE_ATTACHMENT_REQUEST:
      return {
        ...state,
        isDeletingAttachment: action.isDeletingAttachment
      };
    case types.DELETE_ATTACHMENT_COMPLETED:
      return {
        ...state,
        isDeletingAttachment: action.isDeletingAttachment,
        deletedAttachment: action.deletedAttachment
      };
    case types.DELETE_ATTACHMENT_ERROR:
      return {
        ...state,
        isDeletingAttachment: action.isDeletingAttachment,
        deletingAttachmentError: action.deletingAttachmentError
      };
    case types.ADD_ATTACHMENTS_COMPLETED:
      return {
        ...state,
        attachments: action.attachments
      };
    case types.ADD_ATTACHMENTS_ERROR:
      return {
        ...state,
        attachmentsError: action.attachmentsError
      };

    case types.ADD_ATTACHMENTS_SNILS_COMPLETED:
      return {
        ...state,
        attachmentsSnils: action.attachmentsSnils
      };
    case types.ADD_ATTACHMENTS_SNILS_ERROR:
      return {
        ...state,
        attachmentsSnilsError: action.attachmentsSnilsError
      };

    case types.GET_SYSTEM_INFO_REQUEST:
      return {
        ...state,
        isFetchingSystem: action.isFetchingSystem
      };
    case types.GET_SYSTEM_INFO_COMPLETED:
      return {
        ...state,
        isFetchingSystem: action.isFetchingSystem,
        systemInfo: action.systemInfo
      };
    case types.GET_SYSTEM_INFO_ERROR:
      return {
        ...state,
        isFetchingSystem: action.isFetchingSystem,
        systemError: action.systemError
      };

    case types.GET_ORGANIZATIONS_REQUEST:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations
      };
    case types.GET_ORGANIZATIONS_COMPLETED:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
        organizations: action.organizations
      };
    case types.GET_ORGANIZATIONS_ERROR:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
        organizationsError: action.organizationsError
      };

    case types.GET_DEPARTMENTS_REQUEST:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments
      };
    case types.GET_DEPARTMENTS_COMPLETED:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments,
        departments: action.departments
      };
    case types.GET_DEPARTMENTS_ERROR:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments,
        departmentsError: action.departmentsError
      };

    case types.GET_POSTS_REQUEST:
      return {
        ...state,
        isFetchingPosts: action.isFetchingPosts
      };
    case types.GET_POSTS_COMPLETED:
      return {
        ...state,
        isFetchingPosts: action.isFetchingPosts,
        posts: action.posts
      };
    case types.GET_POSTS_ERROR:
      return {
        ...state,
        isFetchingPosts: action.isFetchingPosts,
        postsError: action.postsError
      };

      case types.GET_MUNICIPALS_REQUEST:
        return {
          ...state,
          isFetchingMunicipalsList: action.isFetchingMunicipalsList
        };
      case types.GET_MUNICIPALS_COMPLETED:
        return {
          ...state,
          isFetchingMunicipalsList: action.isFetchingMunicipalsList,
          municipals: action.municipals
        };
      case types.GET_MUNICIPALS_ERROR:
        return {
          ...state,
          isFetchingMunicipalsList: action.isFetchingMunicipalsList,
          municipalsError: action.municipalsError
        };

    case types.UPDATE_PERSON_AVATAR_REQUEST:
      return {
        ...state,
        isUpdatingAvatar: action.isUpdatingAvatar
      };
    case types.UPDATE_PERSON_AVATAR_COMPLETED:
      return {
        ...state,
        isUpdatingAvatar: action.isUpdatingAvatar,
        updatedAvatar: action.updatedAvatar
      };
    case types.UPDATE_PERSON_AVATAR_ERROR:
      return {
        ...state,
        isUpdatingAvatar: action.isUpdatingAvatar,
        avatarUpdateError: action.avatarUpdateError
      };

    default:
      return state;
  }
};
